import { CustomException } from '@tencent/ppd-base-libs';
import { setUpWeixin } from '@tencent/wphk-act-base-framework';
import { cacheFunc, to } from '@tencent/wphk-base-utils';
import { wxBridge } from '@tencent/wphk-base-wx';
import { getJsapiSignWithoutLogin } from '@tencent/wphk-act-base-cgi';
/** 设置免登陆的jsapi */
function setUpSkipLoginWeixin() {
  return wxBridge.weiXinInit({
    openTagList: ['wx-open-launch-weapp'],
    getTicket: async () => {
      const params = {
        url: location.href.split('#')[0],
      };
      return getJsapiSignWithoutLogin(params).then(res => ({
        appId: res.appId,
        nonceStr: res.nonceStr,
        signature: res.signature,
        timestamp: res.timeStamp,
      }));
    },
  });
}

/** 初始化jsapi */
const initWxApi = (isSkipLogin) => {
  if (isSkipLogin) {
    return setUpSkipLoginWeixin();
  }
  return setUpWeixin();
};

// 缓存setupWeixin函数
const cacheSetupWeixin = cacheFunc(initWxApi);

/** 带缓存的初始化微信函数-可以感知微信初始化是否完成*/
export const setUpWeixinInit = async (isSkipLogin = false) => {
  const [err] = await to(cacheSetupWeixin(isSkipLogin));
  if (err) {
    new CustomException(err, 'setUpWeixinFail', '初始化微信分享失败');
  }
};
